module.exports = __webpack_public_path__ + "static/img/highVacuumTechnical.df60576.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/highVacuumTechnical.png
// module id = R3h0
// module chunks = 1